import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../../../../credit-route-config'

export const Route = createFileRoute(
  '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers',
)({
  staticData: toStaticData(
    CREDIT_ROUTES['/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers'],
  ),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
